export default (question, xQuestionName, yQuestionName) =>
  question.choices && question.choices.length
    ? question.choices
        .filter(
          c => c.decisionFrameworkType === question.matrix.decisionFrameworkType
        )
        .map(c => ({
          [xQuestionName]: question.matrix.xQuestionId,
          [yQuestionName]: question.matrix.yQuestionId,
          choiceId: c.id,
          description: c.answer,
          active: true
        }))
    : [];
